import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Button } from "reactstrap";
import { FACEBOOK_ACCOUNTS_SIDE_MODAL_RIGHT } from "../../../../constants/modal.constant";
import { useFacebookCore } from "../../../../cores/facebook";
import { FacebookAccount as Account } from "../../../../cores/facebook/interface/api/get-facebook-account";
import { useInstagramMenssegerCore } from "../../../../cores/instagramMensseger";
import { useGlobalCore } from "../../../../cores/globals";
import { useMeCore } from "../../../../cores/me";

export default function FacebookAccounts({ userToken }: { userToken: string }) {
  const intl = useIntl();
  const { accounts } = useFacebookCore();
  return (
    <div className="p-4 overflow-auto">
      <h2 className="h2 text-center mb-4">
        {intl.formatMessage({ id: "app.social.selectAccount" })}
      </h2>
      {!accounts.length ? (
        <p className="text-center text-muted mb-0">
          {intl.formatMessage({ id: "app.social.noAccountsFound" })}
        </p>
      ) : (
        accounts.map((account) => (
          <FacebookAccount
            key={account.id}
            account={account}
            userToken={userToken}
          />
        ))
      )}
    </div>
  );
}

const FacebookAccount = ({
  account,
  userToken,
}: {
  account: Account;
  userToken: string;
}) => {
  const intl = useIntl();
  const { avatarUrl, name, token } = account;
  const { bind } = useFacebookCore();
  const { bindForPageToken } = useInstagramMenssegerCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { turnOffModal } = useGlobalCore();
  const handleBind = useCallback(async () => {
    const companyId = company!.id;
    await bind(companyId, token, userToken, async () => {
      await bindForPageToken(companyId, token, userToken);
      await getMeSocialSettings(companyId);
    });
    turnOffModal(FACEBOOK_ACCOUNTS_SIDE_MODAL_RIGHT);
  }, [
    bind,
    bindForPageToken,
    company,
    token,
    turnOffModal,
    userToken,
    getMeSocialSettings,
  ]);

  return (
    <div className="align-items-center d-flex p-2 neu-in pointer">
      <img
        style={{ width: "50px", height: "50px" }}
        className="rounded-circle"
        src={avatarUrl}
        alt="Avatar"
      />
      <span className="h5 ml-3"> {name} </span>
      <Button className="ml-auto" color="primary" onClick={handleBind}>
        {intl.formatMessage({ id: "app.sincronyze" })}
      </Button>
    </div>
  );
};
